// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-documents-row {
  margin-bottom: 1px;
  --padding-start: 16px;
  --padding-top: 16px;
  --padding-bottom: 16px;
  --padding-end: 16px;
}
.skeleton-documents-row__icon {
  width: 35px;
  height: 35px;
  margin-inline-end: 12px;
  border-radius: 4px;
  overflow: hidden;
}
.skeleton-documents-row__icon ion-skeleton-text {
  width: 100%;
  height: 100%;
  margin: 0;
}
.skeleton-documents-row__label {
  margin: 0;
}
.skeleton-documents-row__line {
  margin: 0 0 6px;
}
.skeleton-documents-row__line ion-skeleton-text {
  margin: 0;
  height: 15px;
}
.skeleton-documents-row__line--title ion-skeleton-text {
  width: 72%;
}
.skeleton-documents-row__line--sub ion-skeleton-text {
  width: 36%;
  height: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/documents/skeleton-documents-row/skeleton-documents-row.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,SAAA;AACN;AAGE;EACE,SAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EACE,SAAA;EACA,YAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,UAAA;EACA,YAAA;AAJN","sourcesContent":[".skeleton-documents-row {\n  margin-bottom: 1px;\n  --padding-start: 16px;\n  --padding-top: 16px;\n  --padding-bottom: 16px;\n  --padding-end: 16px;\n\n  &__icon {\n    width: 35px;\n    height: 35px;\n    margin-inline-end: 12px;\n    border-radius: 4px;\n    overflow: hidden;\n\n    ion-skeleton-text {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n    }\n  }\n\n  &__label {\n    margin: 0;\n  }\n\n  &__line {\n    margin: 0 0 6px;\n\n    ion-skeleton-text {\n      margin: 0;\n      height: 15px;\n    }\n\n    &--title ion-skeleton-text {\n      width: 72%;\n    }\n\n    &--sub ion-skeleton-text {\n      width: 36%;\n      height: 13px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
